import xss from "xss";

const mapKundenAdressen = (a) => {
  if (!a) return;
  return {
    id: Number(a.id) || Number(a.adressId) || null,
    name: xss(a.name),
    strasse: xss(a.strasse),
    strasse2: xss(a.strasse2),
    plz: xss(a.plz),
    ort: xss(a.ort)
  };
};

const mapKonten = (a) => {
  if (!a) return;
  return {
    nummer: xss(a.nummer),
    blz: xss(a.blz),
    iban: xss(a.iban).replace(/\s+/g, ""),
    bic: xss(a.bic),
    vorname: xss(a.vorname),
    nachname: xss(a.nachname),
    institutsName: xss(a.institutsName),
    kontoArt: xss(a.kontoArt),
    abweichenderInhaber: xss(a.abweichenderInhaber),
  };

};

const mapKunde = (k) => {
  if (!k) return;

  return {
    id: Number(k.id) || null,
    nachname: xss(k.nachname),
    vorname: xss(k.vorname),
    namenszusatz: xss(k.namenszusatz),
    email: xss(k.email),
    strasse1: xss(k.strasse1),
    strasse2: xss(k.strasse2),
    plz: xss(k.plz),
    ort: xss(k.ort),
    gebDatKunde: xss(k.gebDatKunde),
    gebOrtKunde: xss(k.gebOrtKunde),
    gebietsansaessigKz: !isNaN(k.gebietsansaessigKz) ? Number(k.gebietsansaessigKz) : null,
    kundenkonto: xss(k.kundenkonto).replace(/\s+/g, ""),
    nationalitaet: xss(k.nationalitaet),
    personArt: xss(k.personArt),
    rechtlichesHinweis1: !isNaN(k.rechtlichesHinweis1) ? Number(k.rechtlichesHinweis1) : null,
    rechtlichesHinweis2: !isNaN(k.rechtlichesHinweis2) ? Number(k.rechtlichesHinweis2) : null,
    userId: xss(k.userId) || null,
    registrationCountry: xss(k.registrationCountry) || null,
    listKundenAdressen: Array.isArray(k.listKundenAdressen)
      ? k.listKundenAdressen.map(mapKundenAdressen).filter(a => !!a)
      : [],
    konten: Array.isArray(k.konten) ? k.konten.map(mapKonten).filter(a => !!a) : []
  };
};

export default {
  kundenId: null,
  kundenliste: [],
  kunde: {},
  kundeAdressen: [],
  editedKunde: {},
  kontoSelected: true,

  setKontoSelected(value) {
    this.kontoSelected = value;
  },

  isKontoSelected() {
    return this.kontoSelected;
  },

  setKundenList(data) {
    if (!Array.isArray(data)) data = [];
    this.kundenliste = data.map(mapKunde).filter(k => !!k);
  },

  setKunde(data) {
    this.kunde = mapKunde(data || {});
    this.kundenId = this.kunde.id;
    let found = false;
    this.kundenliste = this.kundenliste.map(k => {
      if (Number(k.id) !== this.kundenId) {
        return k;
      } else {
        found = true;
        return this.kunde;
      }
    });
    if (!found) this.kundenliste.push(this.kunde);
  },

  setAdressList(data) {
    if (!Array.isArray(data)) data = [];
    this.kundeAdressen = data.map(mapKundenAdressen).filter(a => !!a);
  },

  setEditedKunde(data) {
    this.kunde = mapKunde(data || {});
    this.editedKunde = {
      vorname: this.kunde.vorname,
      nachname: this.kunde.nachname,
      namenszusatz: this.kunde.namenszusatz,
    };
  },

  setKundenId(kundenId) {
    this.kundenId = Number(kundenId);
    this.kunde = this.kundenliste.find(k => Number(k.id) === this.kundenId);
  },

  resetEditedKunde() {
    this.editedKunde = {};
  },

  getKunde() {
    return this.kunde;
  },

  getAdressList() {
    return this.kundeAdressen;
  },

  getKundenId() {
    return this.kundenId;
  },

  getIbansFromKonten() {
    let ibans = [];
    if (Array.isArray(this.kunde.konten)) {
      this.kunde.konten.forEach(iban => {
        if (!ibans.includes(String(iban.iban))) {
          ibans.push(String(iban.iban));
        }
      });
    }
    return ibans;
  },

  getBestellerInfo(adresseId) {
    // map kunde auf besteller für order
    let kundenLieferAdresse = Array.isArray(this.kunde.listKundenAdressen)
      ? this.kunde.listKundenAdressen.find(a => Number(a.id) === Number(adresseId)) || null
      : null;
    let kundenname = String(this.kunde.vorname ? this.kunde.vorname + " " + this.kunde.nachname : this.kunde.nachname || "");
    let kundenname1, kundenname2;
    if (kundenLieferAdresse !== null && kundenLieferAdresse.name) {
      //überprüfe Länge kunde.vorname und nachname (alte Rage Methode)
      if (kundenname.length > 31 && this.kunde.vorname && this.kunde.personArt !== "J") {
        kundenname = this.kunde.vorname.charAt(0) + ". " + this.kunde.nachname;
      }
      kundenname1 = kundenname.substring(0, 32);
      kundenname2 = String(kundenLieferAdresse.name).trim().substring(0, 32);
    } else {
      if (kundenname.length > 63 && this.kunde.vorname && this.kunde.personArt !== "J") {
        kundenname = this.kunde.vorname.charAt(0) + ". " + this.kunde.nachname;
      }
      kundenname1 = kundenname.substring(0, 32);
      kundenname2 = kundenname.substring(32, 64);
    }
    adresseId = kundenLieferAdresse && kundenLieferAdresse.id;
    return {
      kundenname1,
      kundenname2,
      adresseId: adresseId || null,
      vorname: String(this.kunde.vorname || "").trim(),
      nachname: String(this.kunde.nachname || "").trim(),
      liefername: kundenLieferAdresse !== null && kundenLieferAdresse.name ? String(kundenLieferAdresse.name || "").trim() : "",
      namenszusatz: String(this.kunde.namenszusatz || "").trim(), 
      kundenStrasse1: kundenLieferAdresse !== null ? kundenLieferAdresse.strasse : this.kunde.strasse1,
      kundenStrasse2: kundenLieferAdresse !== null && kundenLieferAdresse.strasse2 !== null ? kundenLieferAdresse.strasse2 : this.kunde.strasse2,
      plz: kundenLieferAdresse !== null ? kundenLieferAdresse.plz : this.kunde.plz,
      kundeOrt: kundenLieferAdresse !== null ? kundenLieferAdresse.ort : this.kunde.ort,
      gebietsansaessigerKz: this.kunde.gebietsansaessigKz,
      persArt: this.kunde.personArt,
      nationalitaetKunde: this.kunde.nationalitaet,
      kundenkonto: this.kunde.kundenkonto,
      gebOrtKunde: this.kunde.gebOrtKunde,
      gebDatKunde: this.kunde.gebDatKunde
    };

  }
};
